import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  pFormControl: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '100%',
  },
  contestSelector: {
    margin: `${theme.spacing(1)} ${theme.spacing(0)}`,
    width: '100%',
  },
  fileUpload: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#e3e8ea',
    height: '30vh',
    border: '2px dashed gray',
    cursor: 'pointer'
  },
  fileUploadText: {
    fontSize: '1.5rem',
    textAlign: 'center',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    padding: 0,
  },
  errMsg: {
    color: 'red',
    marginTop: theme.spacing(2),
  },
  successMsg: {
    color: 'green',
    marginTop: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(2),
  },
  mb1: {
    marginBottom: theme.spacing(1),
  },
  downloadsContainer: {
    margin: `${theme.spacing(3)} ${theme.spacing(2)}`,
    width: '100%',
  },
  container: {
    padding: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  tableCell: {
    fontSize: '18px',
  },
});
